(() => {
  'use strict';
  function initialise(scope) {
    scope.querySelectorAll('[data-ik-standard-shipping]').forEach(block => {
      if (block.dataset.shippingReady) return;
      block.dataset.shippingReady = 'true';
      const page = block.closest('.product') || document;
      const form = block.closest('form.product-form') || page.querySelector('form.product-form');
      const rows = Array.from(block.querySelectorAll('[data-shipping-variant]'));
      let pending = false;
      function update() {
        pending = false;
        const selected = form && form.querySelector('select[name="id"], input[name="id"]');
        const selectedId = selected && String(selected.value);
        const active = rows.find(row => row.dataset.shippingVariant === selectedId) || rows.find(row => row.dataset.shippingVariant === block.dataset.shippingDefault);
        rows.forEach(row => { const hide = row !== active; if (row.hidden !== hide) row.hidden = hide; });
      }
      function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
      if (form) {
        form.addEventListener('change', schedule, true);
        new MutationObserver(schedule).observe(form, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['value','selected','checked','aria-checked']});
      }
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document));
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
